import PropTypes from "prop-types";
import { useState } from "react";
import { useCxt } from "./StructureProvider";
import Draw from "./Draw"
import Table from "./Table"
import Round from "./Round"

// function teamToLeague( team ) {
// 	console.log("[teamToLeague] Not Implemented");
// 	return;
// }

// function teamToELO( team ) {
// 	console.log("[teamToELO] Not Implemented");
// 	return;
// }

// function ELOToPr ( elo1, elo2 ) {
// 	console.log("[ELOToPr] Not Implemented");
// 	return;
// }

function Manager({ language }) {
  const [stageN, setStageN] = useState(0);
  const [workN, setWorkN] = useState(0);
	const [showTable, setShowTable] = useState(1);
	const [isDone, setIsDone] = useState(0);
	
	const {leagueStructure} = useCxt();
	console.log("Manager");
	console.log(leagueStructure);

	function nextWork() {
		// To Do: make this work.(in the note.)
		console.log(showTable, stageN, workN);
		if(showTable){
			// if last table
			if (leagueStructure[stageN].works.length === workN) {
				// if last stage
				if(leagueStructure.length === stageN + 1) {
					setIsDone(1);
				}
				else {
					if(leagueStructure[stageN + 1].stage === "Swiss") setShowTable(0);
					setWorkN(0);
					setStageN(stageN+1);
				}
			}
			
			else setShowTable(0);
		}
		else {
			// if(leagueStructure[stageN].works[workN].type !== "Draw") 
			setShowTable(1);
			setWorkN(prev=>prev+1);
		}
		return;
	}
	
  return (
	<div>
		{isDone ? 
		<div>Done</div> : 
		showTable ? 
		<Table stage={stageN} work={workN} callBack={nextWork} /> :
		leagueStructure[stageN].works[workN].type === "Round" ?
		<Round stage={stageN} work={workN} callBack={nextWork} /> :
		<Draw stage={stageN} work={workN} callBack={nextWork} />}
  </div>
  );
}

Manager.propTypes = {
	language: PropTypes.string.isRequired,
}

export default Manager;